import React from 'react'
import ContentLoader from 'react-content-loader'
import get from 'lodash/get'

import colors from 'colors'

const AttestationFormLoader = () => {
  return (
    <>
      <ContentLoader
        speed={2}
        viewBox="0 0 450 400"
        backgroundColor={`${get(colors, 'cream.dark', '#F4F4F5')}`}
        foregroundColor={`${get(colors, 'grey.lighter', '#e8e8e8')}`}
      >
        <rect x="30" y="20" rx="2" ry="2" width="200" height="25" />
        <rect x="30" y="60" rx="2" ry="2" width="200" height="25" />

        <rect x="30" y="100" rx="2" ry="2" width="200" height="25" />
        <rect x="30" y="140" rx="2" ry="2" width="200" height="25" />

        <rect x="30" y="180" rx="2" ry="2" width="200" height="25" />
        <rect x="30" y="220" rx="2" ry="2" width="200" height="25" />
      </ContentLoader>
    </>
  )
}

export default AttestationFormLoader
